export default {
    methods: {
        formatBrand: function (value) {
            if (value && value.toLowerCase() === "seat")
                return "SEAT"

            if (value && value.toLowerCase() === "cupra")
                return "CUPRA"

            if (value && value.toLowerCase() === "skoda")
                return value.replace('s', 'Š');

            if (value && value.toLowerCase() === "volkswagenerhverv")
                return "Volkswagen Erhverv";

            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        formatThousand: function (value) {
            if (!value) { return '0'; }
            return parseFloat(value)
                .toFixed(0)
                .replace('.', ',')
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        },
        textByBrand: function (text, brand) {
            switch (brand?.toLowerCase() ?? '') {
                case "audi":
                    return text?.audi ?? '';
                case "cupra":
                    return text?.cupra ?? '';
                case "seat":
                    return text?.seat ?? '';
                case "skoda":
                    return text?.skoda ?? '';
                case "volkswagen":
                    return text?.volkswagen ?? '';
                case "porsche":
                    return text?.porsche ?? '';
                default:
                    break;
            }
        }
    }
};